import { createStructuredSelector, createSelector } from 'reselect'
import {
  isMobileSelector,
  loadingSelector,
  usedFreeTrialSelector,
  recaptchaSelector,
  hasSubscriptionSelector
} from 'reduxModules/app/selectors'
import { isLifetimeSelector } from 'reduxModules/auth/selectors'

export const subscriptionPlansSelector = (state) => state.subscriptions.plans

export const subscriptionPlansLanguageSelector = (state) =>
  state.subscriptions.subscriptionPlansLanguage

// SPEC-102 D3: the Lifetime A/B test's audience is anyone without an active
// subscription (logged out included); subscribers keep today's page and the
// upgrade path as it is
export const lifetimeTestEligibleSelector = (state) =>
  !hasSubscriptionSelector(state)

export const lifetimeTestVariantSelector = (state) =>
  state.subscriptions.lifetimeTestVariant

// Lifetime shows when the backend setting says so, or (SPEC-102) when the
// visitor is in the test audience and drew the 'lifetime' variant. The
// backend setting wins when true, so switching Lifetime on for everyone after
// the test needs no frontend change; a visitor who subscribes leaves the
// audience and the variant stops applying.
export const lifetimeEnabledSelector = (state) =>
  Boolean(
    state.subscriptions.subscriptionPlansLanguage?.lifetimeEnabled ||
    (lifetimeTestEligibleSelector(state) &&
      lifetimeTestVariantSelector(state) === 'lifetime')
  )

export const subscriptionBannerIsReadySelector = (state) =>
  state.subscriptions.bannerSubscriptionIsReady

export const globalPromoSelector = (state) => state.app.globalPromo

export const isGlobalPromoEnabledSelector = (state) =>
  Boolean(
    state.app.globalPromo.codename && state.app.globalPromo.codename.length > 0
  )

export const subscriptionPlanSelectors = createSelector(
  [
    isMobileSelector,
    usedFreeTrialSelector,
    globalPromoSelector,
    isGlobalPromoEnabledSelector,
    subscriptionPlansLanguageSelector,
    lifetimeEnabledSelector,
    lifetimeTestEligibleSelector
  ],
  (
    isMobile,
    usedFreeTrial,
    globalPromo,
    isGlobalPromoEnabled,
    subscriptionPlansLanguage,
    lifetimeEnabled,
    lifetimeTestEligible
  ) => ({
    isMobile,
    usedFreeTrial,
    globalPromo,
    isGlobalPromoEnabled,
    subscriptionPlansLanguage,
    lifetimeEnabled,
    lifetimeTestEligible
  })
)

export const giftSubscriptionSelector = (state) => ({
  ...state.subscriptions.giftSubscriptionDetail,
  recaptcha: recaptchaSelector(state)
})

export default createStructuredSelector({
  isMobile: isMobileSelector,
  loading: loadingSelector,
  isGlobalPromoEnabled: isGlobalPromoEnabledSelector,
  lifetimeEnabled: lifetimeEnabledSelector,
  isLifetime: isLifetimeSelector
})

export const subscriptionBannerSelector = createStructuredSelector({
  subscriptionPlansLanguage: subscriptionPlansLanguageSelector,
  bannerSubscriptionIsReady: subscriptionBannerIsReadySelector,
  hasSubscription: hasSubscriptionSelector
})
